import produce from 'immer';

import { RefundPassengersState } from '../types';

import {
	ActionPassengerTypes,
	SetPassengerSelectPayload,
	SET_PASSENGERS,
	SET_PASSENGER_SELECT,
	SET_ALL_PASSENGER_SELECT,
	SetAllPassengerSelectPayload
} from './actions';

const initialState: RefundPassengersState = {};

function passengersReducer(state = initialState, { type, payload }: ActionPassengerTypes) {
	return produce(state, draft => {
		switch (type) {
			case SET_PASSENGERS: {
				Object.assign(draft, payload);
				break;
			}

			case SET_PASSENGER_SELECT: {
				const { id, selected } = payload as SetPassengerSelectPayload;
				const ids = Array.isArray(id) ? id : [id];

				ids.forEach(travellerId => {
					draft[travellerId] = selected;
				});
				break;
			}

			case SET_ALL_PASSENGER_SELECT: {
				const { selected } = payload as SetAllPassengerSelectPayload;
				Object.keys(draft).forEach(id => (draft[id] = selected));
				break;
			}
		}
	});
}

export default passengersReducer;
